const TYPES = {
    GET_PARTICIPATION_FORM: 'GET_PARTICIPATION_FORM',
    GET_PARTICIPATION_FORM_SUCCESS: 'GET_PARTICIPATION_FORM_SUCCESS',
    GET_PARTICIPATION_FORM_FAILED: 'GET_PARTICIPATION_FORM_FAILED',
    SAVE_PARTICIPATION_FORM: 'SAVE_PARTICIPATION_FORM',
    SAVE_PARTICIPATION_FORM_SUCCESS: 'SAVE_PARTICIPATION_FORM_SUCCESS',
    SAVE_PARTICIPATION_FORM_FAILED: 'SAVE_PARTICIPATION_FORM_FAILED',
    HIDE_ERROR_MODAL: 'HIDE_ERROR_MODAL',
    SET_USER_FORM: 'SET_USER_FORM',
    SET_PLAYER_FORM: 'SET_PLAYER_FORM',
    SHOW_MISMATCH_MODAL: 'SHOW_MISMATCH_MODAL'
};

export default {
    TYPES,

    getForm: (payload) => ({ type: TYPES.GET_PARTICIPATION_FORM, payload }),

    getFormSuccess: (payload) => ({ type: TYPES.GET_PARTICIPATION_FORM_SUCCESS, payload }),

    getFormFailed: (payload) => ({ type: TYPES.GET_PARTICIPATION_FORM_FAILED, payload }),

    saveForm: (payload) => ({ type: TYPES.SAVE_PARTICIPATION_FORM, payload }),

    saveFormSuccess: (payload) => ({ type: TYPES.SAVE_PARTICIPATION_FORM_SUCCESS, payload }),

    saveFormFailed: (payload) => ({ type: TYPES.SAVE_PARTICIPATION_FORM_FAILED, payload }),

    hideErrorModal: (payload) => ({ type: TYPES.HIDE_ERROR_MODAL, payload }),

    setPlayerForm: (payload) => ({ type: TYPES.SET_PLAYER_FORM, payload }),

    showMismatchModal: () => ({type: TYPES.SHOW_MISMATCH_MODAL})
};
